import './CardHeader.css';
import type { ComponentChildren } from 'preact';

export interface CardHeaderProps {
  /** Título visível, string pronta do dono (§3.8). */
  title: string;
  /** id do título; o `Card` aponta `labelledBy` para ele (AC-3.8-01). */
  titleId?: string;
  /** Nível do título (a estrutura de títulos é de §15.4); padrão 2. */
  level?: 2 | 3 | 4;
  /** Texto auxiliar à direita (ex.: "Quem lidera para presidente"). Ignorado quando há `actions`. */
  aside?: string;
  /** Ações à direita (`IconButton`s ou `Pager`), cada uma com `aria-label` próprio. Somem na TV (`.tv-hide`). */
  actions?: ComponentChildren;
}

/** Cabeçalho de cartão (§3.8 `CardHeader`): título à esquerda; texto auxiliar ou ações à direita. */
export function CardHeader({ title, titleId, level = 2, aside, actions }: CardHeaderProps) {
  const Heading = `h${level}` as 'h2' | 'h3' | 'h4';
  const hasActions = actions !== undefined && actions !== null && actions !== false;
  return (
    <div class="card-header" data-testid="card-header">
      <Heading class="card-header__title" id={titleId}>
        {title}
      </Heading>
      {hasActions ? (
        <div class="card-header__actions tv-hide">{actions}</div>
      ) : aside ? (
        <p class="card-header__aside">{aside}</p>
      ) : null}
    </div>
  );
}
